<template>
  <div class="card">
    <div class="loading-box" v-if="loading">
      <Loader/>
    </div>
    <div class="deleting-box" v-if="deleting">
      <div class="lds-dual-ring"></div>
      <font-awesome-icon :icon="['fas', 'trash']" class="icon"/>
    </div>

    <div class="dialog-box" v-if="!loading && !deleting">

      <div class="top-row">
        <div class="left-column">

          <div class="image-box">
            <img src="../../assets/image-shape.png" class="default" v-if="!getCoverImage && !getStockImage && !getBackgroundColor">
            <div class="upload-image" v-if="getCoverImage" :style="{ backgroundImage: getCoverImage }"></div>
            <div class="stock-image" v-if="getStockImage" :style="{ backgroundImage: getStockImage }"></div>
            <div class="background-color" v-if="getBackgroundColor" :style="{ backgroundColor: getBackgroundColor }"></div>
            <div class="overflow-play" @click="onPlay" title="Play">
              <font-awesome-icon :icon="['fas', 'play']" class="icon"/>
            </div>
          </div>

        </div>
        <div class="right-column">

          <div class="title-box">
            <div class="title" title="Play" @click="onPlay">{{ dialog.title }}</div>
          </div>

          <div class="tags-box">
            <Tags :exerciseId="id" :loadedTags="dialog.tags"/>
          </div>

          <div class="info-box">

            <div class="counter" title="Questions">
              <font-awesome-icon :icon="['fas', 'comments']" class="icon"/>
              <span class="number">{{dialog.bots}}</span>
            </div>

            <div class="owner" v-if="ownerData">
              <div class="avatar-limiter">
                <Avatar :full="true"/>
              </div>
              <div class="nick">{{ownerData.nick}}</div>
            </div>

          </div>

        </div>
      </div>
      <div class="bottom-row">

        <div class="options-box">
          <div class="edit-box">
            <font-awesome-icon :icon="['fas', 'pen']" class="icon" title="Edit" @click="onEdit"/>
          </div>
          <div class="share-box">
            <font-awesome-icon :icon="['fas', 'share-alt']" class="icon" title="Share" @click="onShare"/>
          </div>
          <div class="copy-box">
            <font-awesome-icon :icon="['fas', 'clone']" class="icon" title="Copy" @click="onCopy"/>
          </div>
          <div class="settings-box">
            <font-awesome-icon :icon="['fas', 'cog']" class="icon" title="Settings" @click="onSettings"/>
          </div>
          <div class="delete-box">
            <font-awesome-icon :icon="['fas', 'trash']" class="icon" title="Delete" @click="onDelete"/>
          </div>
        </div>

      </div>

    </div>

    <div class="recordings-box" v-if="!loading && !deleting">
      <div class="this-week-box" v-if="getThisWeekRecorings.length != 0">
        <RecordingLine v-for="record in getThisWeekRecorings" :key="record._id" :data="record" @delete="onRecordingDelete" @share="onRecordingShare"/>
      </div>
      <div class="show-all-box" v-if="getOlderRecorings.length > 0">
        <div class="button" @click="onOlderSwitch">
          <span v-if="!olderOpen">earlier recordings</span>
          <span v-if="olderOpen">hide</span>
          <font-awesome-icon :icon="['fas', 'angle-double-right']" class="icon" v-if="!olderOpen"/>
          <font-awesome-icon :icon="['fas', 'angle-double-left']" class="icon" v-if="olderOpen"/>
        </div>
      </div>
      <div class="older-box" v-if="getOlderRecorings.length > 0 && olderOpen">
        <RecordingLine v-for="record in getOlderRecorings" :key="record._id" :data="record" @delete="onRecordingDelete" @share="onRecordingShare"/>
      </div>
    </div>
  </div>
</template>

<script>
import alert from '@/lib/alert'
import iframe from '@/lib/iframe'
import axios from 'axios'
import RecordingLine from './RecordingLine'
import Tags from './Tags'
import swal from 'sweetalert'
import Avatar from '@/components/Avatar'
import Loader from '@/components/Loader'

import bg_1 from '@/assets/backgrounds/b_1_s.jpg'
import bg_2 from '@/assets/backgrounds/b_2_s.jpg'
import bg_3 from '@/assets/backgrounds/b_3_s.jpg'
import bg_4 from '@/assets/backgrounds/b_4_s.jpg'
import bg_5 from '@/assets/backgrounds/b_5_s.jpg'
import bg_6 from '../../assets/backgrounds/b_6.jpg'
import bg_7 from '../../assets/backgrounds/b_7.jpg'
import bg_8 from '../../assets/backgrounds/b_8.jpg'
import bg_9 from '../../assets/backgrounds/b_9.jpg'
import bg_10 from '../../assets/backgrounds/b_10.jpg'
import bg_11 from '../../assets/backgrounds/b_11.jpg'
import bg_12 from '../../assets/backgrounds/b_12.jpg'
import bg_13 from '../../assets/backgrounds/b_13.jpg'
import bg_14 from '../../assets/backgrounds/b_14.jpg'
import bg_15 from '../../assets/backgrounds/b_15.jpg'
import bg_16 from '../../assets/backgrounds/b_16.jpg'
import bg_17 from '../../assets/backgrounds/b_17.jpg'
import bg_18 from '../../assets/backgrounds/b_18.jpg'
import bg_19 from '../../assets/backgrounds/b_19.jpg'
import bg_20 from '../../assets/backgrounds/b_20.jpg'
import bg_21 from '../../assets/backgrounds/b_21.jpg'

export default {
  name: 'DialogCard',
  props: {
    shortId: String,
    id: String,
    search: Boolean
  },
  data() {
    return {
      loading: true,
      deleting: false,
      olderOpen: false,
      dialog: {},
      bg_1,
      bg_2,
      bg_3,
      bg_4,
      bg_5,
      bg_6,
      bg_7,
      bg_8,
      bg_9,
      bg_10,
      bg_11,
      bg_12,
      bg_13,
      bg_14,
      bg_15,
      bg_16,
      bg_17,
      bg_18,
      bg_19,
      bg_20,
      bg_21,
      ownerData: null
    }
  },
  components: {
    RecordingLine,
    Tags,
    Avatar,
    Loader
  },
  methods: {
    onOlderSwitch() {
      this.olderOpen = !this.olderOpen;
    },
    onEdit() {
      this.$router.push(`/edit?id=${this.shortId}`);
    },
    onEditTree() {
      this.$router.push(`/edit-tree?id=${this.shortId}`);
    },
    onCopy() {
      console.log('Copy');
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}limitDialogs`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
      }).then(() => {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_SERVER_URL}copyDialog`,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token') 
          },
          data: {
            sourceId: this.id
          }
        }).then(() => {
          console.log('Copy Created');
          alert.showSuccess('Copy Created');
          this.$emit('reload');
        }).catch(() => {
          console.log('Copying Error');
          alert.showError('Copying Error');
        })
      }).catch(() => {
        console.log('Limit Error');
        alert.showError('Dialog limit reached');
      })
    },
    onSettings() {
      this.$emit('openSettings', this.id);
    },
    onDelete() {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this dialog!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          this.deleting = true;
          axios({
            method: 'post',
            url: `${process.env.VUE_APP_SERVER_URL}deleteExercise`,
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('token') 
            },
            data: {
              exerciseId: this.id
            }
          }).then(() => {
            this.$emit('remove', this.shortId);
            swal("Dialog successfully deleted!", {
              icon: "success",
              timer: 2000,
            });
          }).catch(err => {
            alert.showError(err);
          })
        } 
      });
    },
    onShare() {
      this.$emit('share', { title: 'Share Dialogue', link: `${window.location.origin}/hub?exercise_id=${this.id}` })
    },
    onRecordingShare(payload) {
      this.$emit('share', payload);
    },
    onRecordingDelete(id) {
      this.$emit('refresh');
      let index = this.dialog.recordings.findIndex(recording => {
        return recording._id == id;
      })
      this.dialog.recordings.splice(index, 1);
    },
    onPlay() {
      if(this.dialog.activePlayModes.play) {
        iframe.open(`${window.location.origin}/play?exercise_id=${this.id}`);
      } else if(this.dialog.activePlayModes.learn) {
        iframe.open(`${window.location.origin}/learn?exercise_id=${this.id}`);
      } else if(this.dialog.activePlayModes.record) {
        iframe.open(`${window.location.origin}/record?exercise_id=${this.id}`);
      } else {
        iframe.open(`${window.location.origin}/hub?exercise_id=${this.id}`);
      }
    },
    switchCopyOption() {
      return new Promise((resolve, reject) => {
        let state;
        if(this.dialog.blockCopy) {
          state = 'open';
        } else {
          state = 'block'
        }
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_SERVER_URL}changeCopyOption`,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token') 
          },
          data: {
            exerciseId: this.id,
            state
          }
        }).then(() => {
          this.dialog.blockCopy = !this.dialog.blockCopy;
          resolve();
        }).catch(err => {
          this.handleChangeOptionError(err, "You can disable copying by other users in higher subscription plans",);
          reject();
        })
      })
    },
    handleChangeOptionError(err, text) {
      let error = err.response.data.error;
      let message = err.response.data.message;
      if(error == 'plan') {
        swal({
          title: 'Upgrade your plan to GOLD',
          text,
          icon: "warning",
          buttons: [true, "Upgrade"],
        }).then(result => {
          if(result) {
            this.$router.push('/settings');
          }
        })
      } else {
        alert.showError(message);
      }
    },
    loadOwnerInfo() {
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}loadOwnerInfo`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          ownerId : this.dialog.owner
        }
      }).then(result => {
        this.loading = false;
        this.ownerData = result.data.ownerData;
      }).catch(err => {
        this.loading = false;
        console.log(err);
        alert.showError(err);
      })
    }
  },
  created() {
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_SERVER_URL}loadExerciseData`,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') 
      },
      data: {
        shortId: this.shortId
      }
    }).then(result => {
      this.dialog = result.data.exercise;
      this.loadOwnerInfo();
      if(!this.search) {
        this.$emit('loaded', this.dialog.recordings.length);
      }
    }).catch(err => {
      this.loading = false;
      alert.showError(err);
    })
  },
  computed: {
    getThisWeekRecorings() {
      let valid = [];
      let currentDate = new Date();
      const oneDay = 24 * 60 * 60 * 1000;

      this.dialog.recordings.forEach(recording => {
        let recordingDate = new Date(recording.created);
        let dayDiff = Math.round(Math.abs((recordingDate - currentDate) / oneDay));
        if(dayDiff < 8) {
          valid.push(recording);
        }
      });

      return valid.reverse();
    },
    getOlderRecorings() {
      let valid = [];
      let currentDate = new Date();
      const oneDay = 24 * 60 * 60 * 1000;

      this.dialog.recordings.forEach(recording => {
        let recordingDate = new Date(recording.created);
        let dayDiff = Math.round(Math.abs((recordingDate - currentDate) / oneDay));
        if(dayDiff > 7) {
          valid.push(recording);
        }
      });

      return valid.reverse();
    },
    getCoverImage() {
      if(this.dialog.firstBotBackground.type == "upload") {
        let imageTitle = this.dialog.firstBotBackground.data;
        let image = this.dialog.backgroundStore.find(background => {
          return background.name == imageTitle;
        })
        return `url(${image.data})`;
      } else {
        return null;
      }
    },
    getBackgroundColor() {
      if(this.dialog.firstBotBackground.type == "color") {
        let color = this.dialog.firstBotBackground.data.hex;
        return color;
      } else {
        return null;
      }
    },
    getStockImage() {
      if(this.dialog.firstBotBackground.type == "stock") {
        let imageNumber = this.dialog.firstBotBackground.data;
        switch(imageNumber) {
          case 1: return `url(${this.bg_1})`;
          case 2: return `url(${this.bg_2})`;
          case 3: return `url(${this.bg_3})`;
          case 4: return `url(${this.bg_4})`;
          case 5: return `url(${this.bg_5})`;
          case 6: return `url(${this.bg_6})`;
          case 7: return `url(${this.bg_7})`;
          case 8: return `url(${this.bg_8})`;
          case 9: return `url(${this.bg_9})`;
          case 10: return `url(${this.bg_10})`;
          case 11: return `url(${this.bg_11})`;
          case 12: return `url(${this.bg_12})`;
          case 13: return `url(${this.bg_13})`;
          case 14: return `url(${this.bg_14})`;
          case 15: return `url(${this.bg_15})`;
          case 16: return `url(${this.bg_16})`;
          case 17: return `url(${this.bg_17})`;
          case 18: return `url(${this.bg_18})`;
          case 19: return `url(${this.bg_19})`;
          case 20: return `url(${this.bg_20})`;
          case 21: return `url(${this.bg_21})`;
          default: return '';
        }
      } else {
        return null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  width: 55rem;
  height: auto;
  min-height: 14rem;
  display: flex;
  flex-direction: column;
  filter:drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.123));
  background-color: white;
  border-radius: 0.2rem;
  overflow: hidden;
  margin-bottom: 4rem;

  @media (max-width: 900px) {
    width: 100%;
    margin-bottom: 3rem;
  }
}

.loading-box {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.deleting-box {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    position: absolute;
    color: rgba(0, 0, 0, 0.123);
    font-size: 1.8rem;
    animation: pulse 1.5s ease-in-out infinite;
    @keyframes pulse {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.2);
      }
      100% {
        transform: scale(1);
      }
    }
  }
}

.dialog-box {
  width: 100%;
  min-height: 14rem;
  height: auto;
  display: flex;
  flex-direction: column;

  .top-row {
    width: 100%;
    height: auto;
    min-height: 11rem;
    display: flex;

    .left-column {
      min-width: 11rem;
      height: auto;
      display: flex;

      @media (max-width: 650px) {
        min-width: 9rem;
      }
    }

    .right-column {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      padding-left: 0.25rem;
    }
  }

  .bottom-row {
    width: 100%;
    height: 3rem;
    display: flex;
  }

  .image-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 0.9rem;

    img {
      width: 9.5rem;
      border-radius: 0.2rem;
      opacity: 0.6;
      filter: saturate(0);
      @media (max-width: 650px) {
        width: 7rem;
      }
    }

    .upload-image {
      width: 9.5rem;
      height: 9.5rem;
      border-radius: 0.2rem;
      background-repeat: no-repeat;
      background-size: cover;
      @media (max-width: 650px) {
        width: 7rem;
        height: 7rem;
      }
    }

    .stock-image {
      width: 9.5rem;
      height: 9.5rem;
      border-radius: 0.2rem;
      background-repeat: no-repeat;
      background-size: cover;
      @media (max-width: 650px) {
        width: 7rem;
        height: 7rem;
      }
    }

    .background-color {
      width: 9.5rem;
      height: 9.5rem;
      border-radius: 0.2rem;
      @media (max-width: 650px) {
        width: 7rem;
        height: 7rem;
      }
    }

    .overflow-play {
      position: absolute;
      width: 9.5rem;
      height: 9.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 650px) {
        width: 7rem;
        height: 7rem;
      }

      .icon {
        font-size: 2rem;
        color: rgba(255, 255, 255, 0.705);
        opacity: 0;
        transition: 0.4s;
      }

      &:hover {
        cursor: pointer;
        .icon {
          opacity: 1;
        }
      }
    }
  }

  .title-box {
    width: 100%;
    height: auto;
    min-height: 3rem;
    display: flex;
    align-items: center;
    font-size: 1.3rem;
    color: #252629;
    font-weight: 600;
    margin-top: 1rem;
    @media (max-width: 400px) {
      font-size: 1.1rem;
      padding-left: 0.2rem;
    }
    .title {
      cursor: pointer;
    }
  }

  .tags-box {
    width: 100%;
    min-height: 3.5rem;
    height: auto;
    display: flex;
  }

  .info-box {
    width: 100%;
    min-height: 3.5rem;
    display: flex;
    align-items: center;

    .counter {
      color: #252629cb;
      .icon {
        font-size: 1.2rem;
        @media (max-width: 400px) {
          font-size: 1rem;
        }
      }
      .number {
        margin-left: 0.5rem;
        font-size: 1.2rem;
        font-weight: bold;
        @media (max-width: 400px) {
          font-size: 1rem;
        }
      }
    }

    .owner {
      display: flex;
      margin-left: 1.5rem;

      .avatar-limiter {
        width: 2rem;
        height: 2rem;  
        font-size: 1rem;

        @media (max-width: 400px) {
          height: 1.8rem;
          width: 1.8rem;
          font-size: 0.9rem;
        }
      }

      .nick {
        margin-left: 0.5rem;
        width: auto;
        height: 2rem;
        display: flex;
        align-items: center;
        color: #252629cb;
        padding-bottom: 0.15rem;
      }
    }
  }

  .options-box {
    width: 100%;
    height: 100%;
    min-height: 3rem;
    display: flex;
    flex-direction: row;
    padding-left: 0.25rem;

    .edit-box {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      @media (max-width: 650px) {
        flex: 1;
        padding-left: unset;
        padding-right: unset;
      }
      
      .icon {
        font-size: 1.1rem;
        color: #252629cb;
        cursor: pointer;
        transition: 0.3s;
        @media (max-width: 400px) {
          font-size: 1rem;
        }

        &:hover {
          color: #ebc659;
        }
      }
    }

    .edit-tree-box {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      @media (max-width: 650px) {
        flex: 1;
        padding-left: unset;
        padding-right: unset;
      }

      .edit-tree-mini-box {
        cursor: pointer;
        transition: 0.3s;
        color: #252629cb;
        display: flex;

        &:hover {
          color: #ebc659;
        }
      }

      .name {
        font-size: 1rem;
        margin-right: 0.5rem;
        font-weight: bold;
        margin-bottom: 0.2rem;
        @media (max-width: 400px) {
          display: none;
        }
      }
      
      .icon {
        font-size: 1.4rem;
        @media (max-width: 400px) {
          font-size: 1.2rem;
        }
      }
    }

    .copy-box {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      @media (max-width: 650px) {
        flex: 1;
        padding-left: unset;
        padding-right: unset;
      }
      
      .icon {
        font-size: 1.1rem;
        color: #252629cb;
        cursor: pointer;
        transition: 0.3s;
        @media (max-width: 400px) {
          font-size: 1rem;
        }

        &:hover {
          color: #11b6a5;
        }
      }
    }

    .settings-box {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      @media (max-width: 650px) {
        flex: 1;
        padding-left: unset;
        padding-right: unset;
      }
      
      .icon {
        font-size: 1.2rem;
        color: #252629cb;
        cursor: pointer;
        transition: 0.3s;
        @media (max-width: 400px) {
          font-size: 1rem;
        }

        &:hover {
          color: #ebc659;
        }
      }
    }

    .private-box {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      @media (max-width: 650px) {
        flex: 1;
        padding-left: unset;
        padding-right: unset;
      }
      
      .icon {
        font-size: 1.2rem;
        color: #252629cb;
        cursor: pointer;
        transition: 0.3s;
        @media (max-width: 400px) {
          font-size: 1rem;
        }

        &:hover {
          color: #ebc659;
        }
      }
    }

    .share-box {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      @media (max-width: 650px) {
        flex: 1;
        padding-left: unset;
        padding-right: unset;
      }
      
      .icon {
        font-size: 1.1rem;
        color: #252629cb;
        cursor: pointer;
        transition: 0.3s;
        @media (max-width: 400px) {
          font-size: 1rem;
        }

        &:hover {
          color: #11b6a5;
        }
      }
    }

    .delete-box {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 1.25rem;
      padding-right: 1.25rem;
      @media (max-width: 650px) {
        flex: 1;
        padding-left: unset;
        padding-right: unset;
      }
      
      .icon {
        font-size: 1.1rem;
        color: #252629cb;
        cursor: pointer;
        transition: 0.3s;
        @media (max-width: 400px) {
          font-size: 1rem;
        }

        &:hover {
          color: #b61c11;
        }
      }
    }
  }

}

.recordings-box {
  width: 100%;
  height: auto;
  background-color: #ebc659;
  border-top: 2px solid #2526290e;
  display: flex;
  flex-direction: column;

  .this-week-box {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;

    .nothing-box {
      width: 100%;
      height: 3rem;
      display: flex;
      align-items: center;
      padding-left: 1.5rem;
      color: #252629cb;
    }
  }

  .show-all-box {
    width: 100%;
    height: 2rem;
    display: flex;
    background-color: #2526290e;

    @media (max-width: 650px) {
      height: 2.5rem;
    }

    .button {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      margin-left: 1.5rem;
      cursor: pointer;
      transition: 0.2s;
      user-select: none;

      &:hover {
        opacity: 0.7;
      }
    }

    span {
      color: #252629cb;
      font-size: 1.1rem;
      margin-bottom: 0.1rem;
    }

    .icon {
      color: #252629cb;
      margin-left: 0.3rem;
    }
  }

  .older-box {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
  }
}

//Deleting Circle
.lds-dual-ring {
  display: inline-block;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 7px solid #dedede;
  border-color: #dedede transparent #dedede transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>